import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd4d0b8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-col" }
const _hoisted_2 = { class: "type" }
const _hoisted_3 = { class: "fx-1 flex-wrap" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"100%"},
  src: "https://static-s.theckb.com/BusinessMarket/Client/shop_img_back.png",
  alt: ""
}, null, -1))
const _hoisted_6 = {
  key: 1,
  class: "propValue"
}
const _hoisted_7 = {
  key: 2,
  class: "abs prop-num text-ct no-event"
}
const _hoisted_8 = {
  key: 0,
  class: "hand-num-tip-rel"
}
const _hoisted_9 = { class: "hand-num-tip" }
const _hoisted_10 = { class: "flex last rel mb_30" }
const _hoisted_11 = { class: "type" }
const _hoisted_12 = { class: "ft-w-6 fx-1 flex-ter" }
const _hoisted_13 = ["onClick", "src"]
const _hoisted_14 = { style: {"max-width":"100px"} }
const _hoisted_15 = { style: {"overflow":"hidden","text-overflow":"ellipsis","display":"-webkit-box","-webkit-line-clamp":"2","-webkit-box-orient":"vertical"} }
const _hoisted_16 = { class: "fx-1" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "btn" }

import { t } from '@/plugins/i18n'
import { computed, toRaw } from 'vue'
import { useStore } from 'vuex'
import AmountList from './AmountList.vue'
import { arr2map } from '@/plugins/utils'
import useCls from './useCollapse'
import { calc, formatMoneyDirection, showCurrentUnit, calcCeil } from '@/util/useYan'
import ToolTipLadder from './ToolTipLadder.vue'

interface P {
  propKey: string
  propValue?: string
  url?: string
  sku?: any
}

interface G {
  type: string
  props: P[]
  select?: P
}


export default /*#__PURE__*/_defineComponent({
  props: ['skuProps', 'skuList', 'amount', 'product', 'num', 'saleType', 'tourOpen', 'closeSkuTour', 'isMultiGoods'],
  emits: ['updateNum'],
  setup(__props, { emit }) {

const props = __props
const store = useStore()


/** 利用sku生成Map映射 prop对应上后渲染最后一级别的数据数据 */
const skuMap = computed(() =>
  arr2map(props.skuList, (v: any) => v.productProperties)
)

const part = computed(() =>
  props.skuProps.slice(0, -1).map((v: G) => {
    v.select = v.props[0]
    return v
  })
)

const last = computed(() => props.skuProps[props.skuProps.length - 1])

const skuprops = computed(() => part.value.map((v: G) => v.select?.propKey))

const getSku = (v: string) =>
  skuMap.value.get(skuprops.value.concat(v).join(';')) ?? null

// 将sku属性挂到最后一个规格上
const lastSku = computed(() => {
  return last.value?.props
    .map((v: P) => {
      v.sku = getSku(v.propKey)
      if (!v.sku) {
        return false
      }
      if (!('num' in v.sku)) {
        v.sku.num = 0
      }
      return v
    })
    .filter((v: any) => v)
})
const [collapse, height] = useCls(lastSku)

// 第一个规格上显示数量
const skuAmount = computed(() => {
  const amount: any = {}
  Object.entries(props.amount).forEach(([k, v]: any[]) => {
    const props = k.split(';')
    const head = props[0]
    if (amount[head]) {
      amount[head].num += v.num
      amount[head].children.push(v)
    } else {
      amount[head] = {
        num: v.num,
        children: [v]
      }
    }
  })
  return amount
})

const handleSelect = (o: G, v: P) => {
  console.log(o, v)
  o.select = v
  v.url && store.commit('goods/skuImg', v.url)
}

const add = (v: any) => {
  props.closeSkuTour()
  // 直接更新会导致input-number内部值不更新
  emit('updateNum', v.sku)
  // 校验倍数商品
  setTimeout(() => {
    const step = props.saleType === 2 ? 1 : (props.product.batchNumber || 1)
    v.sku.num = Math.ceil(v.sku.num / step) * step
    v.sku.time = new Date()
    emit('updateNum', v.sku)
  }, 10)
}

const bothFormat = (rmb: string) => {
  const convertedMmount = calc(rmb)
  return `${rmb}${showCurrentUnit(props.isMultiGoods)} (${formatMoneyDirection(convertedMmount)})`
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input_number = _resolveComponent("el-input-number")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(part), (o, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: o.type,
        class: "flex mb_10"
      }, [
        _createElementVNode("label", _hoisted_2, _toDisplayString(o.type), 1),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(o.props, (v) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass([{ select: o.select === v }, "mr_10 mb_10 prop-key flex-ter btn rel"]),
              key: v.propKey,
              onClick: ($event: any) => (handleSelect(o, v))
            }, [
              (v.url)
                ? (_openBlock(), _createBlock(_component_el_image, {
                    key: 0,
                    referrerPolicy: "no-referrer",
                    class: "prop-img",
                    src: v.url,
                    alt: ""
                  }, {
                    error: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 2
                  }, 1032, ["src"]))
                : _createCommentVNode("", true),
              (v.propValue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(v.propValue), 1))
                : _createCommentVNode("", true),
              (i === 0 && _unref(skuAmount)[v.propKey]?.num)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, " ×" + _toDisplayString(_unref(skuAmount)[v.propKey]?.num), 1))
                : _createCommentVNode("", true)
            ], 10, _hoisted_4))
          }), 128))
        ])
      ]))
    }), 128)),
    (__props.product.batchNumber && __props.product.batchNumber > 1 && __props.saleType === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('按手起批 1手={num}双', { num: __props.product.batchNumber })), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(last)?.type), 1),
      _createElementVNode("div", {
        class: _normalizeClass(["fx-1", { collapse: _unref(collapse) }]),
        style: _normalizeStyle({ height: _unref(height) })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lastSku), (v, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: v.propKey,
            class: "flex-ter last-item"
          }, [
            _createElementVNode("span", _hoisted_12, [
              (v.url)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    onClick: ($event: any) => (handleSelect(_unref(lastSku), v)),
                    class: "prop-img btn",
                    src: v.url,
                    alt: "",
                    style: {"transform":"scale(0.7)"}
                  }, null, 8, _hoisted_13))
                : _createCommentVNode("", true),
              _createVNode(_component_el_tooltip, {
                placement: "top",
                effect: "light"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(v.propValue), 1)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(v.propValue), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("span", _hoisted_16, [
              _createElementVNode("div", null, _toDisplayString(v.sku.productSellPrice) + _toDisplayString(_unref(showCurrentUnit)(__props.isMultiGoods)), 1),
              _createElementVNode("div", null, "(" + _toDisplayString(_unref(formatMoneyDirection)(_unref(calcCeil)(v.sku.productSellPrice, v.sku?.currency))) + ")", 1)
            ]),
            _withDirectives(_createElementVNode("span", { class: "fx-1 gray" }, _toDisplayString(_unref(t)('X件可售').replace('X', v.sku.channel === 5 ? v.sku.availableQty : v.sku.productStockQuantity)), 513), [
              [_vShow, v.sku.productStockQuantity > 0]
            ]),
            _withDirectives(_createElementVNode("span", { class: "fx-1 rp-color" }, _toDisplayString(_unref(t)('缺货')), 513), [
              [_vShow, v.sku.productStockQuantity === 0]
            ]),
            (__props.tourOpen && index === 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                  _createVNode(_component_el_tooltip, {
                    placement: "top",
                    visible: true
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('请选择商品')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        class: "goods-sku-stepper",
                        size: "small",
                        modelValue: v.sku.num,
                        "onUpdate:modelValue": ($event: any) => ((v.sku.num) = $event),
                        min: 0,
                        disabled: v.sku.productStockQuantity === 0,
                        max: 99999,
                        onChange: ($event: any) => (add(v)),
                        step: __props.saleType === 2 ? 1 : (__props.product.batchNumber || 1)
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange", "step"])
                    ]),
                    _: 2
                  }, 1024)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_18, [
                  _createVNode(ToolTipLadder, {
                    saleType: __props.saleType,
                    ladder: props.product.ladder,
                    num: __props.num,
                    "min-count": props.product.productBuyMininum,
                    sourceCountryInfo: __props.product
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        class: "goods-sku-stepper",
                        size: "small",
                        modelValue: v.sku.num,
                        "onUpdate:modelValue": ($event: any) => ((v.sku.num) = $event),
                        min: 0,
                        disabled: v.sku.productStockQuantity === 0,
                        max: 99999,
                        onChange: ($event: any) => (add(v)),
                        step: __props.saleType === 2 ? 1 : (__props.product.batchNumber || 1)
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange", "step"])
                    ]),
                    _: 2
                  }, 1032, ["saleType", "ladder", "num", "min-count", "sourceCountryInfo"])
                ]))
          ]))
        }), 128))
      ], 6),
      (_unref(lastSku)?.length && (_unref(lastSku)?.length > 4))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "abs expand-line",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (collapse.value = !_unref(collapse)))
          }, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("i", {
                class: _normalizeClass(["fa fa-angle-up", { collapse: _unref(collapse) }])
              }, null, 2)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(AmountList, {
      amount: __props.amount,
      columns: __props.skuProps,
      updateNum: (e) => emit('updateNum', e),
      isMultiGoods: __props.isMultiGoods
    }, null, 8, ["amount", "columns", "updateNum", "isMultiGoods"])
  ]))
}
}

})